module.exports = __webpack_public_path__ + "static/img/pass.7eadebbd.png";